export const CDN_SCRIPT_ID = 'a11ycat-cdn';
export const CDN_URL = 'https://wasp.lexisnexisrisk.com/cdn/a11ycat-latest.min.js';

